<template>

    <div v-if="canAddSubproject">
        <project-form
            :info-uri="infoUri"
        ></project-form>
    </div>
    <div v-else>
        <p>Niet mogelijk om nu toe te voegen</p>
    </div>

</template>

<script>

import ProjectForm from "../../../components/Projects/Form";
import {mapGetters} from "vuex";

export default {

    components: {
        ProjectForm,
    },

    computed: {
        ...mapGetters([
            'can',
            'getProject',
        ]),

        canAddSubproject() {
            return this.project.is_main_project &&
                this.project.is_project &&
                this.can('write', 'projects');
        },

        infoUri() {
            return this.route('api.v1.projects.maininfo', {project_uuid:this.project.uuid});
        },

        project() {
            return this.getProject;
        },
    },

    metaInfo: {
        title:'Subproject toevoegen',
    },

    name:'ProjectFormAddSubProject',

}

</script>
